import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { reducersWeb, reducersCommon } from '@stktk/redux';

const reducer = combineReducers({ ...reducersCommon, ...reducersWeb });
const store = createStore(reducer, applyMiddleware(thunk, createLogger()));

export default store;